import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import { formatNumber } from "../../../../helpers/UtilityHelper";
import _ from 'lodash'
import MaterialTable from "../../../../common/MaterialTable";
import ExportChartDataToExcel from "../../../../common/ExportChartDataToExcel";

export default function PincodeAndCityWise({ data }) {

    const cityRows = _.orderBy(data?.rtoGroupedByCity || [], 'rto', 'desc')
    const pincodeRows = _.orderBy(data?.rtoGroupedByPincode || [], 'rto', 'desc')

    const pincodeWise = [
        {
            label: 'Pincode',
            value: 'pincode',
            align: 'left'
        },
        {
            label: 'RTO Count',
            value: (row) => {
                return formatNumber(row.rto)
            },
            numeric: true,
            align: 'right'
        },
        {
            label: 'Total Shipments',
            value: (row) => {
                return formatNumber(row.total)
            },
            numeric: true,
            align: 'right'
        },
        {
            label: 'RTO %',
            value: (row) => `${row.rtoPercentage}%`,
            numeric: true,
            align: 'right'
        },
    ]

    const cityWise = [
        {
            label: 'City',
            value: 'city',
            align: 'left'
        },
        {
            label: 'RTO Count',
            value: (row) => {
                return formatNumber(row.rto)
            },
            numeric: true,
            align: 'right'
        },
        {
            label: 'Total Shipments',
            value: (row) => {
                return formatNumber(row.total)
            },
            numeric: true,
            align: 'right'
        },
        {
            label: 'RTO %',
            value: (row) => `${row.rtoPercentage}%`,
            numeric: true,
            align: 'right'
        },
    ]

    const cityDownload = [
        {
            label: 'Download Cities with most RTOs',
            fileName: 'CITIES_WITH_MOST_RTOS',
            data: cityRows,
            columns: [
                { label: 'City', value: 'city' },
                { label: 'RTO Count', value: 'rto' },
                { label: 'Total Shipments', value: 'total' },
                { label: 'RTO %', value: (row) => `${row.rtoPercentage}%` },
            ],
        },
    ]

    const pincodeDownload = [
        {
            label: 'Download Pincodes with most RTOs',
            fileName: 'PINCODES_WITH_MOST_RTOS',
            data: pincodeRows,
            columns: [
                { label: 'Pincode', value: 'pincode' },
                { label: 'RTO Count', value: 'rto' },
                { label: 'Total Shipments', value: 'total' },
                { label: 'RTO %', value: (row) => `${row.rtoPercentage}%` },
            ],
        },
    ]

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <Card elevation={1}>
                    <CardHeader title="Cities with most RTO's" action={<ExportChartDataToExcel options={cityDownload} />} />
                    <CardContent sx={{ px: 0 }}>
                        <MaterialTable itemsPerPage={10} minWidth="100%" exportExcel={false} rows={cityRows} columns={cityWise} size="small" />
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} md={6}>
                <Card elevation={1}>
                    <CardHeader title="Pincodes with most RTO's" action={<ExportChartDataToExcel options={pincodeDownload} />} />
                    <CardContent sx={{ px: 0 }}>
                        <MaterialTable itemsPerPage={10} minWidth="100%" exportExcel={false} rows={pincodeRows} columns={pincodeWise} size="small" />
                    </CardContent>
                </Card>
            </Grid>

        </Grid>
    )
}
